export const workData = [
  {
    id: 'p1',
    category: 'projects',
    tags: ['fullstack'],
    createdDate: new Date('2022-03-25'),
    title: 'tralamo.com',
    description:
      'B2C player selling flights, hotels, holidays packages and forex services for domestic and international customers globally.',
    slug: 'tralamo',
    actions: {
      demo: 'https://www.tralamo.com/',
    },
  },
  {
    id: 'p2',
    category: 'projects',
    tags: ['fullstack'],
    createdDate: new Date('2022-03-25'),
    title: 'Eruvaka',
    description:
      'Eruvaka Technologies develops on-farm diagnostic equipment for aquaculture farmers to reduce their risk and increase productivity',
    slug: 'eruvaka',
    actions: {
      demo: 'https://eruvaka.app/',
    },
  },
  {
    id: 'p3',
    category: 'projects',
    tags: ['fullstack'],
    createdDate: new Date('2022-03-25'),
    title: 'Elevator Doors, Inc.',
    description: 'Business website for the hospital',
    slug: 'edi-eci',
    actions: {
      articles: '',
    },
  },
  {
    id: 'p4',
    category: 'projects',
    tags: ['browser extension'],
    createdDate: new Date('2022-03-25'),
    title: 'Captain Chucky',
    description:
      'A Google chrome bookmark organizer with cool icons and drag & drop feature.',
    slug: 'Captain Chucky',
    actions: {
      demo: 'https://captnchuckysorders.com/',
    },
  },
  {
    id: 'p5',
    category: 'projects',
    tags: ['frontend'],
    createdDate: new Date('2022-03-25'),
    title: 'Curated Handicrafts',
    description: 'E-commerce website for handicrafts',
    slug: 'curated-handicrafts',
    actions: {
      article: '',
    },
  },
  {
    id: 'p6',
    category: 'projects',
    tags: ['fullstack'],
    createdDate: new Date('2022-03-25'),
    title: 'Divis Vanishers',
    description: 'E-commerce website for laundry services',
    slug: 'divis-vanishers',
    actions: {
      articles: '',
    },
  },
  {
    id: 'p7',
    category: 'projects',
    tags: ['fullstack'],
    createdDate: new Date('2022-03-25'),
    title: 'Sindhura Hospital',
    description: 'Business website for the hospital',
    slug: 'sindhura-hospital',
    actions: {
      articles: '',
    },
  },
  {
    id: 'p8',
    category: 'projects',
    tags: ['browser extension'],
    createdDate: new Date('2022-03-25'),
    title: 'I Love Bookmarks',
    description:
      'A Google chrome bookmark organizer with cool icons and drag & drop feature.',
    slug: 'i-love-bookmarks',
    actions: {
      demo: 'https://chrome.google.com/webstore/detail/i-love-bookmarks/dfgjmhdilimpooppfbinonkmldfgjkab?hl=en-US',
    },
  },
];
